import { InjectionToken } from '@angular/core';

export const COMMONS_ENV = new InjectionToken<any>('CommonsEnv');
